import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";
//Importé directement : ce filet doit rester disponible même quand un fragment de code manque
import ErrorBoundary from "../components/ErrorBoundary";
import NotificationsActeurIndex from "../backoffice/acteurs/notifications";
import NotificationsIndex from "../backoffice/admin/notifications";
//Chargée comme les autres pages : l'import direct créerait un cycle, ce module exportant myroutes
const PageNotFound = lazy(() => import("../components/PageNotFound"));
const DashboardActeur = lazy(() => import("../backoffice/acteurs/dashboardActeur"));
const Dashboard = lazy(() => import("../backoffice/admin/dashboard"));
const DashboardNewUser = lazy(() => import("../backoffice/dashboardNewUser"));
const Login = lazy(() => import("../backoffice/auth/login"));
//import Register from "../backoffice/auth/register";
//import Loginparties from "../backoffice/auth/loginparties";
//import Accueil from "../backoffice/accueil";
const TableaudebordStats = lazy(() => import("../backoffice/tableaudebordStats"));
const Statistiques = lazy(() => import("../backoffice/statistiques"));
const StatutIndex = lazy(() => import("../backoffice/admin/parametres/statuts"));
const StatutsCreate = lazy(() => import("../backoffice/admin/parametres/statuts/create"));
const StatutsEdit = lazy(() => import("../backoffice/admin/parametres/statuts/edit"));
const UtilisateursIndex = lazy(() => import("../backoffice/admin/utilisateurs"));
const UtilisateursCreate = lazy(() => import("../backoffice/admin/utilisateurs/create"));
const UtilisateursEdit = lazy(() => import("../backoffice/admin/utilisateurs/edit"));
const ProfilsIndex = lazy(() => import("../backoffice/admin/parametres/profils"));
const ProfilsCreate = lazy(() => import("../backoffice/admin/parametres/profils/create"));
const ProfilsEdit = lazy(() => import("../backoffice/admin/parametres/profils/edit"));
const CategoriesIndex = lazy(() => import("../backoffice/admin/parametres/categories"));
const CategoriesCreate = lazy(() => import("../backoffice/admin/parametres/categories/create"));
const CategoriesEdit = lazy(() => import("../backoffice/admin/parametres/categories/edit"));
const ObjetsIndex = lazy(() => import("../backoffice/admin/parametres/Objets"));
const ObjetsCreate = lazy(() => import("../backoffice/admin/parametres/Objets/create"));
const ObjetsEdit = lazy(() => import("../backoffice/admin/parametres/Objets/edit"));
const RolesmembresIndex = lazy(() => import("../backoffice/admin/parametres/rolesmembres"));
const RolesmembresCreate = lazy(() => import("../backoffice/admin/parametres/rolesmembres/create"));
const RolesmembresEdit = lazy(() => import("../backoffice/admin/parametres/rolesmembres/edit"));
const ChambresIndex = lazy(() => import("../backoffice/admin/parametres/chambres"));
const ChambresCreate = lazy(() => import("../backoffice/admin/parametres/chambres/create"));
const ChambresEdit = lazy(() => import("../backoffice/admin/parametres/chambres/edit"));
const HabilitationsIndex = lazy(() => import("../backoffice/admin/parametres/habilitations"));
const HabilitationsCreate = lazy(() => import("../backoffice/admin/parametres/habilitations/create"));
const HabilitationsEdit = lazy(() => import("../backoffice/admin/parametres/habilitations/edit"));
const MotifsvalidationsIndex = lazy(() => import("../backoffice/admin/parametres/motifsvalidations"));
const MotifsvalidationsCreate = lazy(() => import("../backoffice/admin/parametres/motifsvalidations/create"));
const PartiesIndex = lazy(() => import("../backoffice/admin/parametres/parties"));
//import PartiesCreate from "../backoffice/admin/parametres/parties/create";
//import PartiesIndexActeur from "../backoffice/acteurs/parametresActeurs/partiesActeur";
//import PartiesCreateActeur from "../backoffice/acteurs/parametresActeurs/partiesActeur/create";
//import PartiesprofilsIndex from "../backoffice/admin/parametres/partiesprofils";
//import PartiesprofilsCreate from "../backoffice/admin/parametres/partiesprofils/create";
const StatutsdossiersIndex = lazy(() => import("../backoffice/admin/parametres/statutsdossiers"));
const StatutsdossiersCreate = lazy(() => import("../backoffice/admin/parametres/statutsdossiers/create"));
const DossiersdocumentsIndex = lazy(() => import("../backoffice/admin/dossierspartiesdocuments"));
const DossiersdocumentsIndexActeur = lazy(() => import("../backoffice/acteurs/dossierspartiesdocumentsActeur"));
const DossiersdocumentsCreateActeur = lazy(() => import("../backoffice/acteurs/dossierspartiesdocumentsActeur/create"));
const TypespartiesIndex = lazy(() => import("../backoffice/admin/parametres/typesparties"));
const TypespartiesCreate = lazy(() => import("../backoffice/admin/parametres/typesparties/create"));
const DossiersIndex = lazy(() => import("../backoffice/admin/Dossiers"));
//import DossiersCreate from "../backoffice/admin/Dossiers/create";
//import DossiersEdit from "../backoffice/admin/Dossiers/edit";
const DossiersShow = lazy(() => import("../backoffice/admin/Dossiers/show"));
const CreerDossiers = lazy(() => import("../backoffice/admin/Dossiers/creer"));
const DossiersIndexActeur = lazy(() => import("../backoffice/acteurs/DossiersActeurs"));
//import DossiersCreateActeur from "../backoffice/acteurs/DossiersActeurs/create";
const SaisinesIndex = lazy(() => import("../backoffice/admin/saisines"));
const SaisinesCreate = lazy(() => import("../backoffice/admin/saisines/create"));
//import PartiesmembresIndex from "../backoffice/admin/parametres/partiesmembres";
//import PartiesmembresCreate from "../backoffice/admin/parametres/partiesmembres/create";
const CivilitesCreate = lazy(() => import("../backoffice/admin/parametres/civilites/create"));
const CivilitesIndex = lazy(() => import("../backoffice/admin/parametres/civilites"));
const CivilitesEdit = lazy(() => import("../backoffice/admin/parametres/civilites/edit"));
const DatesaudiencesIndex = lazy(() => import("../backoffice/admin/datesaudiences"));
const DatesaudiencesCreate = lazy(() => import("../backoffice/admin/datesaudiences/create"));
//import PartiesdossiersIndex from "../backoffice/admin/parametres/partiesdossiers";
//import PartiesdossiersCreate from "../backoffice/admin/parametres/partiesdossiers/create";
const AssujettiesIndex = lazy(() => import("../backoffice/admin/assujetties"));
const AssujettiesCreate = lazy(() => import("../backoffice/admin/assujetties/create"));
const AssujettiesEdit = lazy(() => import("../backoffice/admin/assujetties/edit"));
const AssujettiesIndexActeur = lazy(() => import("../backoffice/acteurs/assujettiesActeurs"));
const AssujettiesEditActeur = lazy(() => import("../backoffice/acteurs/assujettiesActeurs/edit"));
const AssujettiesCreateActeurs = lazy(() => import("../backoffice/acteurs/assujettiesActeurs/create"));
const ChangePassword = lazy(() => import("../backoffice/auth/changepassword"));
const ChangePasswordActeur = lazy(() => import("../backoffice/auth/changepasswordActeur"));
const PolesIndex = lazy(() => import("../backoffice/admin/parametres/poles"));
const PolesCreate = lazy(() => import("../backoffice/admin/parametres/poles/create"));
const PolesEdit = lazy(() => import("../backoffice/admin/parametres/poles/edit"));
const ProceduresIndex = lazy(() => import("../backoffice/admin/parametres/procedures"));
const ProceduresCreate = lazy(() => import("../backoffice/admin/parametres/procedures/create"));
const ProceduresEdit = lazy(() => import("../backoffice/admin/parametres/procedures/edit"));
const TypesproceduresEdit = lazy(() => import("../backoffice/admin/parametres/typesprocedures/edit"));
const TypesproceduresIndex = lazy(() => import("../backoffice/admin/parametres/typesprocedures"));
const TypesproceduresCreate = lazy(() => import("../backoffice/admin/parametres/typesprocedures/create"));
const StatutsdossiersEdit = lazy(() => import("../backoffice/admin/parametres/statutsdossiers/edit"));
const DossiersdocumentsCreate = lazy(() => import("../backoffice/admin/dossierspartiesdocuments/create"));
const CreerDossiersActeurs = lazy(() => import("../backoffice/acteurs/DossiersActeurs/creer"));
//import DatesaudiencesIndexActeur from "../backoffice/acteurs/datesaudiencesActeurs";
const RolesaudiencesIndex = lazy(() => import("../backoffice/admin/rolesaudiences"));
const RolesaudiencesCreate = lazy(() => import("../backoffice/admin/rolesaudiences/create"));
const UtilisateursShow = lazy(() => import("../backoffice/admin/utilisateurs/show"));
const ChambresmembresIndex = lazy(() => import("../backoffice/admin/parametres/chambresmembres"));
const ChambresmembresCreate = lazy(() => import("../backoffice/admin/parametres/chambresmembres/create"));
const ChambresmembresEdit = lazy(() => import("../backoffice/admin/parametres/chambresmembres/edit"));
const Voirtout = lazy(() => import("../backoffice/admin/parametres/voirtout"));
const CalendriersGlobalsIndex = lazy(() => import("../backoffice/admin/parametres/calendriersglobals"));
const CalendriersGlobalsCreate = lazy(() => import("../backoffice/admin/parametres/calendriersglobals/create"));
const CalendriersGlobalsEdit = lazy(() => import("../backoffice/admin/parametres/calendriersglobals/edit"));
const CalendriersGlobalsImportxlsx = lazy(() => import("../backoffice/admin/parametres/calendriersglobals/importxlsx"));
const CalendriersIndex = lazy(() => import("../backoffice/admin/parametres/calendriers"));
const CalendriersCreate = lazy(() => import("../backoffice/admin/parametres/calendriers/create"));
const CalendriersEdit = lazy(() => import("../backoffice/admin/parametres/calendriers/edit"));
const DatesaudiencesEdit = lazy(() => import("../backoffice/admin/datesaudiences/edit"));
const PaiementDossier = lazy(() => import("../backoffice/paiementDossier"));
const DemandeArretsCreate = lazy(() => import("../backoffice/acteurs/demandearrets/demandeArretsCreate"));
const DemandeArrets = lazy(() => import("../backoffice/demandeArrets"));
const DemandesArretsIndex = lazy(() => import("../backoffice/admin/demandesarrets"));
const StatutsJuridiquesIndex = lazy(() => import("../backoffice/admin/parametres/statutsjuridiques"));
const StatutsJuridiquesCreate = lazy(() => import("../backoffice/admin/parametres/statutsjuridiques/create"));
const StatutsJuridiquesEdit = lazy(() => import("../backoffice/admin/parametres/statutsjuridiques/edit"));
const TypesdocumentsIndex = lazy(() => import("../backoffice/admin/parametres/typesdocuments"));
const TypesdocumentsCreate = lazy(() => import("../backoffice/admin/parametres/typesdocuments/create"));
const TypesdocumentsEdit = lazy(() => import("../backoffice/admin/parametres/typesdocuments/edit"));
const TypesacteursIndex = lazy(() => import("../backoffice/admin/parametres/typesacteurs"));
const TypesacteursEdit = lazy(() => import("../backoffice/admin/parametres/typesacteurs/edit"));
const TypesacteursCreate = lazy(() => import("../backoffice/admin/parametres/typesacteurs/create"));
const PaiementsIndex = lazy(() => import("../backoffice/admin/paiements"));
const TribunauxIndex = lazy(() => import("../backoffice/admin/parametres/tpi"));
const DossiersShowActeurs = lazy(() => import("../backoffice/acteurs/DossiersActeurs/show"));
const CalendriersProceduresCreate = lazy(() => import("../backoffice/admin/calendriersprocedures/create"));
const CalendriersProceduresIndex = lazy(() => import("../backoffice/admin/calendriersprocedures"));
const HistoriqueActionsIndex = lazy(() => import("../backoffice/admin/parametres/historiqueactions"));
const InsertCodeOtp = lazy(() => import("../backoffice/auth/insertCodeOtp"));
const ForgotPassword = lazy(() => import("../backoffice/auth/forgotPassword"));
const NatureAffairesIndex = lazy(() => import("../backoffice/admin/parametres/natureaffaires"));
const DemandesArretsActeurIndex = lazy(() => import("../backoffice/acteurs/demandesarrets"));
const PaiementDemandeArret = lazy(() => import("../backoffice/paiementDemandeArret"));
const LoginForDemandes = lazy(() => import("../backoffice/auth/loginForDemandes"));
const HistoriqueConnexionsIndex = lazy(() => import("../backoffice/admin/parametres/historiqueconnexions"));
const JoursFeriesIndex = lazy(() => import("../backoffice/admin/parametres/joursferies"));
const JonctionsIndex = lazy(() => import("../backoffice/admin/jonctions"));
const ModesPaiementsEdit = lazy(() => import("../backoffice/admin/parametres/modespaiements/edit"));
const ModesPaiementsCreate = lazy(() => import("../backoffice/admin/parametres/modespaiements/create"));
const ModesPaiementsIndex = lazy(() => import("../backoffice/admin/parametres/modespaiements"));
const RequetesOrdonnancesActeurIndex = lazy(() => import("../backoffice/acteurs/requetesOrdonnances"));
const RequetesOrdonnancesActeurCreate = lazy(() => import("../backoffice/acteurs/requetesOrdonnances/create"));
const PaiementRequete = lazy(() => import("../backoffice/paiementRequete"));
const AttestationsInstancesActeurIndex = lazy(() => import("../backoffice/acteurs/attestationsInstances"));
const AttestationsInstancesCreate = lazy(() => import("../backoffice/acteurs/attestationsInstances/create"));
const AttestationsInstancesIndex = lazy(() => import("../backoffice/admin/attestationsInstances"));
const RequetesOrdonnancesIndex = lazy(() => import("../backoffice/admin/requetesOrdonnances"));
const PaiementAttestationInstance = lazy(() => import("../backoffice/paiementAttestationInstance"));
const AssujettiesRegister = lazy(() => import("../backoffice/auth/assujettiesRegister"));
const FraisPaiementsCreate = lazy(() => import("../backoffice/admin/parametres/fraispaiements/create"));
const FraisPaiementsIndex = lazy(() => import("../backoffice/admin/parametres/fraispaiements"));
const FraisPaiementsEdit = lazy(() => import("../backoffice/admin/parametres/fraispaiements/edit"));
const StatutsRequetesCreate = lazy(() => import("../backoffice/admin/parametres/statutsrequetes/create"));
const StatutsRequetesIndex = lazy(() => import("../backoffice/admin/parametres/statutsrequetes"));
const StatutsRequetesEdit = lazy(() => import("../backoffice/admin/parametres/statutsrequetes/edit"));
const SuitesRequetesIndex = lazy(() => import("../backoffice/admin/parametres/suitesrequetes"));
const SuitesRequetesCreate = lazy(() => import("../backoffice/admin/parametres/suitesrequetes/create"));
const SuitesRequetesEdit = lazy(() => import("../backoffice/admin/parametres/suitesrequetes/edit"));
const AttestationsRadiationsIndex = lazy(() => import("../backoffice/admin/attestationsRadiations"));
const AttestationsRadiationsActeurIndex = lazy(() => import("../backoffice/acteurs/attestationsRadiations"));
const AttestationsRadiationsCreate = lazy(() => import("../backoffice/acteurs/attestationsRadiations/create"));
const PaiementAttestationRadiation = lazy(() => import("../backoffice/paiementAttestationRadiation"));
const PaiementsListe = lazy(() => import("../backoffice/admin/paiements/liste"));
const RelevePaiements = lazy(() => import("../backoffice/admin/paiements/relevePaiements"));
const CommunicationElectronique = lazy(() => import("../backoffice/admin/communication/communicationelectronique"));
const ListeCommunications = lazy(() => import("../backoffice/admin/communication"));
const EtatPaiements = lazy(() => import("../backoffice/admin/paiements/etatPaiements"));
const StatistiquesGlobal = lazy(() => import("../backoffice/statistiquesGlobal"));
const AttestationsIndex = lazy(() => import("../backoffice/admin/attestationsPourvoiAndNot"));
const AttestationsPouvoirCreate = lazy(() => import("../backoffice/acteurs/attestationsPourvoiAndNot/create"));
const AttestationsActeursIndex = lazy(() => import("../backoffice/acteurs/attestationsPourvoiAndNot"));
const PaiementAttestationPourvoi = lazy(() => import("../backoffice/paiementAttestationsPourvoi"));
const LegalisationsActeurIndex = lazy(() => import("../backoffice/acteurs/legalisations"));
const LegalisationsActeurCreate = lazy(() => import("../backoffice/acteurs/legalisations/create"));
const PaiementLegalisation = lazy(() => import("../backoffice/paiementLegalisation"));
const LegalisationsIndex = lazy(() => import("../backoffice/admin/legalisations"));
//Déclaration des noms des routes

const myroutes = {

    ///############## BACK OFFICE PATH ######################///

    /* accueil: "/accueil",*/
    login: "/",
    login_acteurs: "/admin/login",
    login_parties: "/acteurs/authentification",
    register: "/register",
    assujetties_register:"/assujetties-register",
    dashboard: "/admin/dashboard",
    dashboard_acteur: "/acteurs/dashboard",
    dashboard_newuser: "/acteurs/dashboard_newuser",
    tableaudebordstats: "/acteurs/tableaudebordstats",
    statistiques: "/acteurs/statistiques",

    //change password
    change_password: "/admin/change_password",

    //Admin statistiques
    statistiques_globales: "/admin/statistiques/statistiquesGlobal",

    //change password Acteur
    change_passwordacteur: "/parties/change_passwordacteur",

    //profils
    profils_index: "/admin/profils/index",
    profils_create: "/admin/profils/create",
    profils_edit: "/admin/profils/edit",


    //statuts
    statuts_index: "/admin/statuts/index",
    statuts_create: "/admin/statuts/create",
    statuts_edit: "/admin/statuts/edit",

    //utilisateurs
    utilisateurs_index: "/admin/utilisateurs/index",
    utilisateurs_create: "/admin/utilisateurs/create",
    utilisateurs_edit: "/admin/utilisateurs/edit",
    utilisateurs_show: "/admin/utilisateurs/show",


    //categories
    categories_index: "/admin/categories/index",
    categories_create: "/admin/categories/create",
    categories_edit: "/admin/categories/edit",

    //objets
    objets_index: "/admin/objets/index",
    objets_create: "/admin/objets/create",
    objets_edit: "/admin/objets/edit",

    //roles membres
    rolesmembres_index: "/admin/rolesmembres/index",
    rolesmembres_create: "/admin/rolesmembres/create",
    rolesmembres_edit: "/admin/rolesmembres/edit",

    //chambres
    chambres_index: "/admin/chambres/index",
    chambres_create: "/admin/chambres/create",
    chambres_edit: "/admin/chambres/edit",

    //habilitations
    habilitations_index: "/admin/habilitations/index",
    habilitations_create: "/admin/habilitations/create",
    habilitations_edit: "/admin/habilitations/edit",
    

    //frais paiements
    fraispaiements_index: "/admin/fraispaiements/index",
    fraispaiements_create: "/admin/fraispaiements/create",
    fraispaiements_edit: "/admin/fraispaiements/edit",

    //motifsvalidations
    motifsvalidations_index: "/admin/motifsvalidations/index",
    motifsvalidations_create: "/admin/motifsvalidations/create",
    motifsvalidations_edit: "/admin/motifsvalidations/edit",

    //parties
    parties_index: "/admin/parties/index",
    parties_create: "/admin/parties/create",
    parties_edit: "/admin/parties/edit",

    //partiesacteurs
    partiesacteurs_index: "/parties/partiesacteurs/index",
    partiesacteurs_create: "/parties/partiesacteurs/create",
    partiesacteurs_edit: "/parties/partiesacteurs/edit",

    //partiesmembres
    partiesmembres_index: "/admin/partiesmembres/index",
    partiesmembres_create: "/admin/partiesmembres/create",
    partiesmembres_edit: "/admin/partiesmembres/edit",

    //partiesprofils
    partiesprofils_index: "/admin/partiesprofils/index",
    partiesprofils_create: "/admin/partiesprofils/create",
    partiesprofils_edit: "/admin/partiesprofils/edit",

    //statutsdossiers
    statutsdossiers_index: "/admin/statutsdossiers/index",
    statutsdossiers_create: "/admin/statutsdossiers/create",
    statutsdossiers_edit: "/admin/statutsdossiers/edit",

    //typesparties
    typesparties_index: "/admin/typesparties/index",
    typesparties_create: "/admin/typesparties/create",
    typesparties_edit: "/admin/typesparties/edit",

    //dossiers
    dossiers_index: "/admin/dossiers/index",
    //dossiers_create: "/admin/dossiers/create",
    //dossiers_edit: "/admin/dossiers/edit",
    creer_dossier: "/admin/dossiers/creer",
    dossiers_show: "/admin/dossiers/show",

    //dossiers
    dossiersacteurs_index: "/parties/dossiersacteurs/index",
    //dossiersacteurs_create: "/parties/dossiersacteurs/create",
    //dossiersacteurs_edit: "/parties/dossiersacteurs/edit",
    dossiersacteurs_creer: "/parties/dossiersacteurs/creer",
    dossiersacteurs_show: "/parties/dossiersacteurs/show",


    //saisines
    saisines_index: "/admin/saisines/index",
    saisines_create: "/admin/saisines/create",
    saisines_edit: "/admin/saisines/edit",

    //civilites
    civilites_index: "/admin/civilites/index",
    civilites_create: "/admin/civilites/create",
    civilites_edit: "/admin/civilites/edit",

    //datesaudiences
    datesaudiences_index: "/admin/datesaudiences/index",
    datesaudiences_create: "/admin/datesaudiences/create",
    datesaudiences_edit: "/admin/datesaudiences/edit",
    datesaudiencesacteurs_index: "/admin/datesaudiencesacteurs/index",


    //parties dossiers
    partiesdossiers_index: "/admin/partiesdossiers/index",
    partiesdossiers_create: "/admin/partiesdossiers/create",
    partiesdossiers_edit: "/admin/partiesdossiers/edit",

    //assujetties
    assujetties_inscrits: "/admin/assujetties/inscrits",
    assujetties_index: "/admin/assujetties/index",
    assujetties_create: "/admin/assujetties/create",
    assujetties_edit: "/admin/assujetties/edit",

    //assujetties
    assujettiesacteurs_index: "/acteurs/assujettiesacteurs/index",
    assujettiesacteurs_create: "/acteurs/assujettiesacteurs/create",
    assujettiesacteurs_edit: "/acteurs/assujettiesacteurs/edit",

    //dossierspartiesdocuments
    dossierspartiesdocuments_index: "/admin/dossierspartiesdocuments/index",
    dossierspartiesdocuments_create: "/admin/dossierspartiesdocuments/create",

    //dossierspartiesdocuments
    dossierspartiesdocumentsacteurs_index: "/acteurs/dossierspartiesdocumentsacteurs/index",
    dossierspartiesdocumentsacteurs_create: "/acteurs/dossierspartiesdocumentsacteurs/create",

    //poles
    poles_index: "/admin/poles/index",
    poles_create: "/admin/poles/create",
    poles_edit: "/admin/poles/edit",

    //procedures
    procedures_index: "/admin/procedures/index",
    procedures_create: "/admin/procedures/create",
    procedures_edit: "/admin/procedures/edit",

    //typesprocedures
    typesprocedures_index: "/admin/typesprocedures/index",
    typesprocedures_create: "/admin/typesprocedures/create",
    typesprocedures_edit: "/admin/typesprocedures/edit",

    //chambres membres
    chambresmembres_index: "/admin/chambresmembres/index",
    chambresmembres_create: "/admin/chambresmembres/create",
    chambresmembres_edit: "/admin/chambresmembres/edit",

    //calendriers globals
    calendriersglobals_index: "/admin/calendriersglobals/index",
    calendriersglobals_create: "/admin/calendriersglobals/create",
    calendriersglobals_edit: "/admin/calendriersglobals/edit",
    calendriersglobals_importxlsx: "/admin/calendriersglobals/importxlsx",



    //calendriers 
    calendriers_index: "/admin/calendriers/index",
    calendriers_create: "/admin/calendriers/create",
    calendriers_edit: "/admin/calendriers/edit",


    //voir tous les parametres
    voirtout: "/admin/parametres/voirtout",
    //rolesaudiences
    rolesaudiences_index: "/admin/rolesaudiences/index",
    rolesaudiences_create: "/admin/rolesaudiences/create",

    //Page de paiement frais dossier
    paiement_dossier: "/paiement/:referenceDossier",

    //Demande de copie d'arret
    demande_arret_create: "/admin/demande/arret/create",
    demande_arret_index: "/admin/demande/arret/index",


    //Demande de copie d'arret sur le frontoffice
    demande_arret: "/demande/arret",

    //statuts juridiques
    statutsjuridiques_index: "/admin/statutsjuridiques/index",
    statutsjuridiques_create: "/admin/statutsjuridiques/create",
    statutsjuridiques_edit: "/admin/statutsjuridiques/edit",

    //statuts requetes
    statutsrequetes_index: "/admin/statutsrequetes/index",
    statutsrequetes_create: "/admin/statutsrequetes/create",
    statutsrequetes_edit: "/admin/statutsrequetes/edit",

    //suites requetes
    suitesrequetes_index: "/admin/suitesrequetes/index",
    suitesrequetes_create: "/admin/suitesrequetes/create",
    suitesrequetes_edit: "/admin/suitesrequetes/edit",

    //types documents
    typesdocuments_index: "/admin/typesdocuments/index",
    typesdocuments_create: "/admin/typesdocuments/create",
    typesdocuments_edit: "/admin/typesdocuments/edit",

    //types acteurs
    typesacteurs_index: "/admin/typesacteurs/index",
    typesacteurs_create: "/admin/typesacteurs/create",
    typesacteurs_edit: "/admin/typesacteurs/edit",

    //paiements
    paiements_index: "/admin/paiements/index",
    paiements_liste : "/admin/paiements/liste",
    releve_paiements: "/admin/paiements/relevepaiements",
    etat_paiements : "/admin/paiements/etatPaiements",

    //tribunaux
    tribunaux_index: "/admin/tribunaux/index",

    //Calendriers des procédures
    calendriersprocedures_create: "/admin/calendriersprocedures/create",
    calendriersprocedures_index: "/admin/calendriersprocedures/index",

    //historiques des actions
    historiqueactions_index: "/admin/historiqueactions/index",

    historiqueconnexions_index: "/admin/historiqueconnexions/index",

    //Insertion du code otp
    forgot_password: "/forgot-password",
    //Insertion du code otp
    insert_codeotp: "/new-password",
    login_for_demandes: "/login/service",

    //nature affaires
    natureaffaires_index: "/parties/natureaffaires/index",

    demande_arret_acteur_index: "/acteurs/demande-arret/index",
    paiement_demande: "/paiement/service/:referenceDemande",

    joursferies_index: "/admin/joursferies/index",
    jonctionsdossier_index: "/admin/jonctionsdossier/index",

    //modes de paiements
    modespaiements_index: "/admin/modespaiements/index",
    modespaiements_create: "/admin/modespaiements/create",
    modespaiements_edit: "/admin/modespaiements/edit",

    //Requêtes aux fins d'ordonnances
    dossiersacteurs_mes_requetes: "/acteurs/requetes-ordonnances/index",
    dossiersacteurs_add_requete: "/acteurs/requetes-ordonnances/create",
    paiement_requete: "/paiement/requete/:referenceRequete",
    //Admin
    dossiers_mes_requetes: "/admin/requetes-ordonnances/index",

    //Attestation d'instance
    dossiersacteurs_mes_attestations: "/acteurs/attestations-instances/index",
    dossiersacteurs_add_attestation: "/acteurs/attestations-instances/create",
    paiement_attestation: "/paiement/attestation/:referenceAttestation",

    paiement_attestation_pourvoi: "/paiement/attestation/pourvoi/:referenceAttestation",

    //Attestation d'instance
    dossiersacteurs_mes_attestations_radiations: "/acteurs/attestations-radiations/index",
    dossiersacteurs_add_attestation_radiations: "/acteurs/attestations-radiations/create",
    paiement_attestation_radiations: "/paiement/attestation-radiation/:referenceAttestationRadiation",

    //Admin
    dossiers_mes_attestations: "/admin/attestations-instances/index",
    //Admin
    dossiers_mes_attestations_radiations: "/admin/attestations-radiations/index",

    /// - Admin légalisations de pièces
    admin_legalisations: "/admin/legalisations-de-pieces/index",

    //Communication électronique
    communication_electronique: "/admin/communication/communicationelectronique",
    communication_index: "/admin/communication/index",

    //###Centralier les attestations
    //Attestations de radiation
    attestations_radiation: '/attestations/radiation',
    
    // Attestations de pourvoi et non pourvoi pour ADMIN, GEC etc
    dossiers_mes_attestations_pourvoi: '/admin/attestations/:type/index/:is_pourvoi',
    
    //Attestation de pourvoi et non pourvoi pour ACTEURS
    dossiersacteurs_mes_attestations_pourvoi: '/acteurs/attestations/:type/index/:is_pourvoi',
    dossiersacteurs_add_attestation_pourvoi:'/acteurs/attestations/:type/create/:is_pourvoi',


    /// - Léglisations de pièces acteurs
    dossiersacteurs_mes_legalisations: "/acteurs/legalisations-de-pieces/index",
    dossiersacteurs_add_legalisation: "/acteurs/legalisations-de-pieces/create",
    paiement_legalisation: "/paiement/legalisations-de-pieces/:referenceLegalisation",

    /// Notifications

    notifications_index: "/notifications",
    notifications_acteur: "/acteur/notifications",
    

}

export { myroutes };


// Affiché pendant le téléchargement du chunk de la page demandée
function RouteFallback() {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Chargement...</span>
      </div>
      <p className="mt-3 text-muted">Chargement de la page...</p>
    </div>
  );
}

export default function Webroute() {
    const profils = useSelector((state) => state.auth.profil);
    
    const profil_habilitation = useSelector((state) => state.auth.profil_habilitation);

    // Accès aux statistiques globales. Le repli sur INTERFACE-ADMIN est
    // transitoire, le temps que l'habilitation VOIR-STATS soit créée côté
    // backend et affectée aux profils.
    const peutVoirStats =
        profil_habilitation.includes("VOIR-STATS") ||
        profil_habilitation.includes("INTERFACE-ADMIN");

    return (
        <BrowserRouter>
            {/* Rattrape notamment les fragments de code introuvables après un deploiement en cours de session */}
            <ErrorBoundary>
            <Suspense fallback={<RouteFallback />}>
            <Routes>

                <Route path={myroutes.login_for_demandes} name="login_for_demandes" element={<LoginForDemandes />} />
                

                <Route path={myroutes.paiement_demande} name="paiement_demande" element={<PaiementDemandeArret />} />
                <Route path={myroutes.paiement_dossier} name="paiement_dossier" element={<PaiementDossier />} />
                {!profils.includes("SJ") && <Route path={myroutes.demande_arret} name="demande_arret" element={<DemandeArrets />} />}
                <Route path={myroutes.forgot_password} name="forgot_password" element={<ForgotPassword />} />
                <Route path={myroutes.insert_codeotp} name="insert_codeotp" element={<InsertCodeOtp />} />
                <Route path={myroutes.paiement_requete} name="paiement_requete" element={<PaiementRequete />} />
                <Route path={myroutes.paiement_attestation} name="paiement_attestation" element={<PaiementAttestationInstance />} />
                <Route path={myroutes.paiement_attestation_radiations} name="paiement_attestation_radiations" element={<PaiementAttestationRadiation />} />

                <Route path={myroutes.paiement_attestation_pourvoi} name="paiement_attestation_pourvoi" element={<PaiementAttestationPourvoi />} />
                <Route path={myroutes.paiement_legalisation} name="paiement_legalisation" element={<PaiementLegalisation />} />

                {/** Start Route BACK OFFICE */}
                {profils.includes("AJ") && <Route path={myroutes.dashboard_acteur} name="dashboard_acteur" element={<DashboardActeur />} />}
                {profils.includes("AJ") && <Route path={myroutes.demande_arret_acteur_index} name="demande_arret_acteur_index" element={<DemandesArretsActeurIndex />} />}
                
                {profils.includes("USER") && <Route path={myroutes.dashboard_newuser} name="dashboard_newuser" element={<DashboardNewUser />} />}

                {profil_habilitation.includes("INTERFACE-ADMIN") && <Route path={myroutes.dashboard} name="dashboard" element={<Dashboard />} />}
                <Route path={myroutes.login} name="login" element={<Login />} />

                {/**Inscription assujetties * */}
                  
                 <Route path={myroutes.assujetties_register} name="assujetties-register" element={<AssujettiesRegister/>} />
                

                {profils.includes("AJ") && <Route path={myroutes.dossiersacteurs_mes_requetes} name="dossiersacteurs_mes_requetes" element={<RequetesOrdonnancesActeurIndex />} />}
                {profils.includes("AJ") && <Route path={myroutes.dossiersacteurs_add_requete} name="dossiersacteurs_add_requete" element={<RequetesOrdonnancesActeurCreate />} />}

                {profils.includes("AJ") && <Route path={myroutes.dossiersacteurs_mes_attestations} name="dossiersacteurs_mes_attestations" element={<AttestationsInstancesActeurIndex />} />}
                {profils.includes("AJ") && <Route path={myroutes.dossiersacteurs_add_attestation} name="dossiersacteurs_add_attestation" element={<AttestationsInstancesCreate />} />}

                {profils.includes("AJ") && <Route path={myroutes.dossiersacteurs_mes_legalisations} name="dossiersacteurs_mes_legalisations" element={<LegalisationsActeurIndex />} />}
                {profils.includes("AJ") && <Route path={myroutes.dossiersacteurs_add_legalisation} name="dossiersacteurs_add_legalisation" element={<LegalisationsActeurCreate />} />}

                {profils.includes("AJ") && <Route path={myroutes.dossiersacteurs_mes_attestations_radiations} name="dossiersacteurs_mes_attestations_radiations" element={<AttestationsRadiationsActeurIndex />} />}
                {profils.includes("AJ") && <Route path={myroutes.dossiersacteurs_add_attestation_radiations} name="dossiersacteurs_add_attestation_radiations" element={<AttestationsRadiationsCreate />} />}

                {/**
                 * <Route path={myroutes.accueil} name="accueil" element={<Accueil />} />
                 * <Route path={myroutes.parties_create} name="parties_create" element={<PartiesCreate />} />
                 * <Route path={myroutes.login_parties} name="login_parties" element={<Loginparties />} />
                 * <Route path={myroutes.register} name="register" element={<Register />} />
                 * //Parties Acteur 
                 * <Route path={myroutes.partiesacteurs_index} name="partiesacteurs_index" element={<PartiesIndexActeur />} />
                 * <Route path={myroutes.partiesacteurs_create} name="partiesacteurs_create" element={<PartiesCreateActeur />} />
                 * //Parties profils 
                 * <Route path={myroutes.partiesprofils_index} name="partiesprofils_index" element={<PartiesprofilsIndex />} />
                 * <Route path={myroutes.partiesprofils_create} name="partiesprofils_create" element={<PartiesprofilsCreate />} />
                 * // Parties membres 
                 * <Route path={myroutes.partiesmembres_index} name="partiesmembres_index" element={<PartiesmembresIndex />} />
                 * <Route path={myroutes.partiesmembres_create} name="partiesmembres_create" element={<PartiesmembresCreate />} />
                 *  // DatesaudiencesActeurs 
                 * <Route path={myroutes.datesaudiencesacteurs_index} name="datesaudiencesacteurs_index" element={<DatesaudiencesIndexActeur />} />
                 * Parties dossiers
                 * <Route path={myroutes.partiesdossiers_index} name="partiesdossiers_index" element={<PartiesdossiersIndex />} />
                 * <Route path={myroutes.partiesdossiers_create} name="partiesdossiers_create" element={<PartiesdossiersCreate />} />
                 */}



                {/* Statistiques globales : gouvernées par VOIR-STATS.
                    Le repli sur INTERFACE-ADMIN est TRANSITOIRE — il évite que
                    tout le monde perde la page tant que le backend n'a pas créé
                    et affecté l'habilitation. À retirer une fois VOIR-STATS
                    déployée et affectée aux profils concernés. */}
                {peutVoirStats &&
                    <Route path={myroutes.statistiques_globales} name="statistiquesGlobales" element={<StatistiquesGlobal />} />}

                {profil_habilitation.includes("INTERFACE-ADMIN") &&
                    <>
                        <Route path={myroutes.statistiques} name="statistiques" element={<Statistiques />} />
                        <Route path={myroutes.tableaudebordstats} name="tableaudebordstats" element={<TableaudebordStats />} />

                        {/** changes password */}
                        <Route path={myroutes.change_password} name="change_password" element={<ChangePassword />} />
                        {/** rolesaudiences*/}
                        <Route path={myroutes.rolesaudiences_index} name="rolesaudiences_index" element={<RolesaudiencesIndex />} />

                    </>}



                {/** utilisateurs */}
                {(profils.includes("SUPERADMIN") || profils.includes("ADMIN") || profils.includes("GEC")) &&
                    <>
                    <Route path={myroutes.utilisateurs_index} name="utilisateurs_index" element={<UtilisateursIndex />} />
                    
                    <Route path={myroutes.utilisateurs_edit} name="utilisateurs_edit" element={<UtilisateursEdit />} />
                    </>
                
                }
                {(profils.includes("SUPERADMIN") || profils.includes("ADMIN") ) &&
                    <>
                        {/** Parties */}
                        <Route path={myroutes.parties_index} name="parties_index" element={<PartiesIndex />} />

                        <Route path={myroutes.voirtout} name="voirtout" element={<Voirtout />} />
                    
                        
                        <Route path={myroutes.utilisateurs_create} name="utilisateurs_create" element={<UtilisateursCreate />} />
                        {/**
                         * <Route path={myroutes.utilisateurs_edit} name="utilisateurs_edit" element={<UtilisateursEdit />} />
                           <Route path={`${myroutes.utilisateurs_show}/:ref`} name="utilisateurs_show" element={<UtilisateursShow />} />
                         */}

                        {/** statuts */}
                        <Route path={myroutes.statuts_index} name="statuts_index" element={<StatutIndex />} />
                        <Route path={myroutes.statuts_create} name="statuts_create" element={< StatutsCreate />} />
                        <Route path={myroutes.statuts_edit} name="statuts_edit" element={< StatutsEdit />} />
                        {/** profils */}
                        <Route path={myroutes.profils_index} name="profils_index" element={<ProfilsIndex />} />
                        <Route path={myroutes.profils_create} name="profils_create" element={<ProfilsCreate />} />
                        <Route path={myroutes.profils_edit} name="profils_edit" element={<ProfilsEdit />} />

                        {/** categories */}
                        <Route path={myroutes.categories_index} name="categories_index" element={<CategoriesIndex />} />
                        <Route path={myroutes.categories_create} name="categories_create" element={<CategoriesCreate />} />
                        <Route path={myroutes.categories_edit} name="categories_edit" element={<CategoriesEdit />} />

                        {/** objets */}
                        <Route path={myroutes.objets_index} name="objets_index" element={<ObjetsIndex />} />
                        <Route path={myroutes.objets_create} name="objets_create" element={<ObjetsCreate />} />
                        <Route path={myroutes.objets_edit} name="objets_edit" element={<ObjetsEdit />} />


                        {/** roles membres */}
                        <Route path={myroutes.rolesmembres_index} name="rolesmembres_index" element={<RolesmembresIndex />} />
                        <Route path={myroutes.rolesmembres_create} name="rolesmembres_create" element={<RolesmembresCreate />} />
                        <Route path={myroutes.rolesmembres_edit} name="rolesmembres_edit" element={<RolesmembresEdit />} />


                        {/** chambres */}
                        <Route path={myroutes.chambres_index} name="chambres_index" element={<ChambresIndex />} />
                        <Route path={myroutes.chambres_create} name="chambres_create" element={<ChambresCreate />} />
                        <Route path={myroutes.chambres_edit} name="chambres_edit" element={<ChambresEdit />} />

                        {/** habilitations */}
                        <Route path={myroutes.habilitations_index} name="habilitations_index" element={<HabilitationsIndex />} />
                        <Route path={myroutes.habilitations_create} name="habilitations_create" element={<HabilitationsCreate />} />
                        <Route path={myroutes.habilitations_edit} name="habilitations_edit" element={<HabilitationsEdit />} />

                            {/** Frais de paiements */}
                        <Route path={myroutes.fraispaiements_index} name="fraispaiements_index" element={<FraisPaiementsIndex/>} />
                        <Route path={myroutes.fraispaiements_create} name="fraispaiements_create" element={<FraisPaiementsCreate />} />
                        <Route path={myroutes.fraispaiements_edit} name="fraispaiements_edit" element={<FraisPaiementsEdit />} />



                        {/** Types parties */}
       
                        <Route path={myroutes.typesparties_index} name="typesparties_index" element={<TypespartiesIndex />} />
                        <Route path={myroutes.typesparties_create} name="typesparties_create" element={<TypespartiesCreate />} />

                        {/** statuts juridiques  */}
                        <Route path={myroutes.statutsjuridiques_index} name="statutsjuridiques_index" element={<StatutsJuridiquesIndex />} />
                        <Route path={myroutes.statutsjuridiques_create} name="statutsjuridiques_create" element={<StatutsJuridiquesCreate />} />
                        <Route path={myroutes.statutsjuridiques_edit} name="statutsjuridiques_edit" element={<StatutsJuridiquesEdit />} />

                        {/** statuts requetes  */}
                        <Route path={myroutes.statutsrequetes_index} name="statutsrequetes_index" element={<StatutsRequetesIndex />} />
                        <Route path={myroutes.statutsrequetes_create} name="statutsrequetes_create" element={<StatutsRequetesCreate />} />
                        <Route path={myroutes.statutsrequetes_edit} name="statutsrequetes_edit" element={<StatutsRequetesEdit />} />

                        {/** statuts requetes  */}
                        <Route path={myroutes.suitesrequetes_index} name="suitesrequetes_index" element={<SuitesRequetesIndex />} />
                        <Route path={myroutes.suitesrequetes_create} name="suitesrequetes_create" element={<SuitesRequetesCreate />} />
                        <Route path={myroutes.suitesrequetes_edit} name="suitesrequetes_edit" element={<SuitesRequetesEdit />} />

                        
                        {/** Statuts dossiers */}
                        <Route path={myroutes.statutsdossiers_index} name="statutsdossiers_index" element={<StatutsdossiersIndex />} />
                        <Route path={myroutes.statutsdossiers_create} name="statutsdossiers_create" element={<StatutsdossiersCreate />} />
                        <Route path={myroutes.statutsdossiers_edit} name="statutsdossiers_edit" element={<StatutsdossiersEdit />} />

                        {/** Assujetties */}
                        
                        <Route path={myroutes.assujetties_index} name="assujetties_index" element={<AssujettiesIndex />} />
                        <Route path={myroutes.assujetties_create} name="assujetties_create" element={<AssujettiesCreate />} />
                        <Route path={myroutes.assujetties_edit} name="assujetties_edit" element={<AssujettiesEdit />} />

                        {/** Civilites */}
                        <Route path={myroutes.civilites_index} name="civilites_index" element={<CivilitesIndex />} />
                        <Route path={myroutes.civilites_create} name="civilites_create" element={<CivilitesCreate />} />
                        <Route path={myroutes.civilites_edit} name="civilites_edit" element={<CivilitesEdit />} />

                        {/** Poles*/}
                        <Route path={myroutes.poles_index} name="poles_index" element={<PolesIndex />} />
                        <Route path={myroutes.poles_create} name="poles_create" element={<PolesCreate />} />
                        <Route path={myroutes.poles_edit} name="poles_edit" element={<PolesEdit />} />

                        {/** Procedures*/}
                        <Route path={myroutes.procedures_index} name="procedures_index" element={<ProceduresIndex />} />
                        <Route path={myroutes.procedures_create} name="procedures_create" element={<ProceduresCreate />} />
                        <Route path={myroutes.procedures_edit} name="procedures_edit" element={<ProceduresEdit />} />

                        {/** typesprocedures*/}
                        <Route path={myroutes.typesprocedures_index} name="typesprocedures_index" element={<TypesproceduresIndex />} />
                        <Route path={myroutes.typesprocedures_create} name="typesprocedures_create" element={<TypesproceduresCreate />} />
                        <Route path={myroutes.typesprocedures_edit} name="typesprocedures_edit" element={<TypesproceduresEdit />} />

                        {/** chambres membres */}
                        <Route path={myroutes.chambresmembres_index} name="chambresmembres_index" element={<ChambresmembresIndex />} />
                        <Route path={myroutes.chambresmembres_create} name="chambresmembres_create" element={<ChambresmembresCreate />} />
                        <Route path={myroutes.chambresmembres_edit} name="chambresmembres_edit" element={<ChambresmembresEdit />} />

                        {/** calendriers globales */}
                        <Route path={myroutes.calendriersglobals_index} name="calendriersglobals_index" element={<CalendriersGlobalsIndex />} />
                        <Route path={myroutes.calendriersglobals_create} name="calendriersglobals_create" element={<CalendriersGlobalsCreate />} />
                        <Route path={myroutes.calendriersglobals_edit} name="calendriersglobals_edit" element={<CalendriersGlobalsEdit />} />
                        <Route path={myroutes.calendriersglobals_importxlsx} name="calendriersglobals_importxlsx" element={<CalendriersGlobalsImportxlsx />} />

                        {/** calendriers  */}
                        <Route path={myroutes.calendriers_index} name="calendriers_index" element={<CalendriersIndex />} />
                        <Route path={myroutes.calendriers_create} name="calendriers_create" element={<CalendriersCreate />} />
                        <Route path={myroutes.calendriers_edit} name="calendriers_edit" element={<CalendriersEdit />} />

                        {/** Motifs validations */}
                        <Route path={myroutes.motifsvalidations_index} name="motifsvalidations_index" element={<MotifsvalidationsIndex />} />
                        <Route path={myroutes.motifsvalidations_create} name="motifsvalidations_create" element={<MotifsvalidationsCreate />} />

                        {/** Types documents */}
                        <Route path={myroutes.typesdocuments_index} name="typesdocuments_index" element={<TypesdocumentsIndex />} />
                        <Route path={myroutes.typesdocuments_create} name="typesdocuments_create" element={<TypesdocumentsCreate />} />
                        <Route path={myroutes.typesdocuments_edit} name="typesdocuments_edit" element={<TypesdocumentsEdit />} />

                        {/** Types acteurs */}
                        <Route path={myroutes.typesacteurs_index} name="typesacteurs_index" element={<TypesacteursIndex />} />
                        <Route path={myroutes.typesacteurs_create} name="typesacteurs_create" element={<TypesacteursCreate />} />
                        <Route path={myroutes.typesacteurs_edit} name="typesacteurs_edit" element={<TypesacteursEdit />} />

                        {/** Tribunaux */}
                        <Route path={myroutes.tribunaux_index} name="tribunaux_index" element={<TribunauxIndex />} />

                        {/** Historiques des actions */}
                        <Route path={myroutes.historiqueactions_index} name="historiqueactions_index" element={<HistoriqueActionsIndex />} />

                        {/** Nature des affaires */}
                        <Route path={myroutes.natureaffaires_index} name="natureaffaires_index" element={<NatureAffairesIndex />} />

                        {/** Historiques des connexions */}
                        <Route path={myroutes.historiqueconnexions_index} name="historiqueconnexions_index" element={<HistoriqueConnexionsIndex />} />

                        <Route path={myroutes.joursferies_index} name="joursferies_index" element={<JoursFeriesIndex />} />

                        {/** Modes de paiements */}
                        <Route path={myroutes.modespaiements_index} name="modespaiements_index" element={<ModesPaiementsIndex />} />
                        <Route path={myroutes.modespaiements_create} name="modespaiements_create" element={< ModesPaiementsCreate />} />
                        <Route path={myroutes.modespaiements_edit} name="modespaiements_edit" element={< ModesPaiementsEdit />} />

                        

                    </>
                }


                {/** Dossiers */}
                {!profils.includes("AJ") && !profils.includes("USER") && <Route path={myroutes.dossiers_index} name="dossiers_index" element={<DossiersIndex />} />}


                {(profil_habilitation.includes("ADMIN-RW")) &&
                    <>
                        <Route path={myroutes.creer_dossier} name="creer_dossier" element={<CreerDossiers />} />
                    </>}

                {(profils.includes("GEC") || profils.includes("AGEC") || profils.includes("GCH") || profils.includes("PDT") || profils.includes("ADMIN") || profils.includes("SUPERADMIN") || profils.includes("PC") || profils.includes("CCC")) && <Route path={`${myroutes.dossiers_show}/:ref`} name="dossiers_show" element={<DossiersShow />} />}


                {/** DossiersActeurs */}
                {profils.includes("AJ") &&
                    <>
                        <Route path={myroutes.dossiersacteurs_index} name="dossiersacteurs_index" element={<DossiersIndexActeur />} />
                        <Route path={`${myroutes.dossiersacteurs_show}/:ref`} name="dossiersacteurs_show" element={<DossiersShowActeurs />} />
                        <Route path={myroutes.dossiersacteurs_creer} name="dossiersacteurs_creer" element={<CreerDossiersActeurs />} />
                        <Route path={myroutes.dossiersacteurs_add_attestation_pourvoi} name="dossiersacteurs_add_attestation_pourvoi" element={<AttestationsPouvoirCreate />} />
                        <Route path={myroutes.dossiersacteurs_mes_attestations_pourvoi} name="dossiersacteurs_mes_attestations_pourvoi" element={<AttestationsActeursIndex />} />

                    </>}


                {/** Saisines */}
                {profil_habilitation.includes("INTERFACE-ADMIN") && !profils.includes("PDT") && <>
                    <Route path={myroutes.saisines_index} name="saisines_index" element={<SaisinesIndex />} />
                    {/** Datesaudiences */}
                    <Route path={myroutes.datesaudiences_index} name="datesaudiences_index" element={<DatesaudiencesIndex />} />
                    <Route path={myroutes.datesaudiences_create} name="datesaudiences_create" element={<DatesaudiencesCreate />} />
                    <Route path={myroutes.datesaudiences_edit} name="datesaudiences_edit" element={<DatesaudiencesEdit />} />

                    {/** Assujetties acteurs*/}
                    <Route path={myroutes.assujettiesacteurs_index} name="assujettiesacteurs_index" element={<AssujettiesIndexActeur />} />
                    <Route path={myroutes.assujettiesacteurs_create} name="assujettiesacteurs_create" element={<AssujettiesCreateActeurs />} />
                    <Route path={myroutes.assujettiesacteurs_edit} name="assujettiesacteurs_edit" element={<AssujettiesEditActeur />} />

                    {/** documents dossiers parties */}
                    <Route path={myroutes.dossierspartiesdocuments_index} name="dossierspartiesdocuments_index" element={<DossiersdocumentsIndex />} />
                    <Route path={myroutes.dossierspartiesdocuments_create} name="dossierspartiesdocuments_create" element={<DossiersdocumentsCreate />} />

                    {/** documents dossiers parties acteurs */}
                    <Route path={myroutes.dossierspartiesdocumentsacteurs_index} name="dossierspartiesdocumentsacteurs_index" element={<DossiersdocumentsIndexActeur />} />
                    <Route path={myroutes.dossierspartiesdocumentsacteurs_create} name="dossierspartiesdocumentsacteurs_create" element={<DossiersdocumentsCreateActeur />} />

                </>}

                {profils.includes("SUPERADMIN") && <Route path={myroutes.saisines_create} name="saisines_create" element={<SaisinesCreate />} />}
                
                

                {/** changes password */}
                {profils.includes("AJ") && <Route path={myroutes.change_passwordacteur} name="change_passwordacteur" element={<ChangePasswordActeur />} />}

                {/** rolesaudiences*/}
                {(profils.includes("GEC") || profils.includes("AGEC") || profils.includes("GCH") || profils.includes("ADMIN") || profils.includes("SUPERADMIN")) && <>
                    <Route path={myroutes.rolesaudiences_create} name="rolesaudiences_create" element={<RolesaudiencesCreate />} />
                    <Route path={myroutes.calendriersprocedures_create} name="calendriersprocedures_create" element={<CalendriersProceduresCreate />} />
                    <Route path={myroutes.calendriersprocedures_index} name="calendriersprocedures_index" element={<CalendriersProceduresIndex />} />

                    <Route path={myroutes.jonctionsdossier_index} name="jonctionsdossier_index" element={<JonctionsIndex />} />

                </>}

                 {(profils.includes("ADMIN") || (profils.includes("SUPERADMIN") || profils.includes("SJ") || profils.includes("PDT"))) && <>
                    
                    {/**Requetes aux fins d'ordonnance */}
                    <Route path={`${myroutes.dossiers_mes_requetes}/:ref?`} name="dossiers_mes_requetes" element={<RequetesOrdonnancesIndex />} />

                </>}

                {(profils.includes("ADMIN") || (profils.includes("GEC") || profils.includes("SUPERADMIN"))) && <>
                    
                    {/**Attestation d'instance */}
                    <Route path={`${myroutes.dossiers_mes_attestations}/:ref?`} name="dossiers_mes_attestations" element={<AttestationsInstancesIndex />} />
                    {/**Attestation de radiation de role */}
                    <Route path={`${myroutes.dossiers_mes_attestations_radiations}/:ref?`} name="dossiers_mes_attestations_radiations" element={<AttestationsRadiationsIndex />} />
                    {/**Attestation de pouvoir et non pouvoir */}
                    <Route path={myroutes.dossiers_mes_attestations_pourvoi} name="dossiers_mes_attestations_pourvoi" element={<AttestationsIndex />} />
                    
                    {/**Légalisations */}
                    <Route path={`${myroutes.admin_legalisations}/:ref?`} name="admin_legalisations" element={<LegalisationsIndex />} />
                     
                </>}

                {/***demande de copie d'arrêt */}
                {!profils.includes("USER") && !profils.includes("SJ") && <Route path={myroutes.demande_arret_create} name="demande_arret_create" element={<DemandeArretsCreate />} />}
                {(profil_habilitation.includes("INTERFACE-ADMIN") && !profils.includes("CCC") && !profils.includes("PC") ) && !profils.includes("SJ") && <Route path={`${myroutes.demande_arret_index}/:ref?`} name="demande_arret_index" element={<DemandesArretsIndex />} />}

                {/** Paiements */}
                {(profils.includes("ADMIN") || profils.includes("SUPERADMIN") || profils.includes("PDT") || profils.includes("GEC")) && <Route path={myroutes.paiements_index} name="paiements_index" element={<PaiementsIndex />} />}

                {/** Comptabilité */}

                {(profils.includes('CMPT') || profils.includes('SUPERADMIN') || profils.includes('ADMIN')) && <Route path={myroutes.paiements_liste} name="liste_paiements" element={<PaiementsListe />} />}

                {(profils.includes('CMPT') || profils.includes('SUPERADMIN') || profils.includes('ADMIN')) && <Route path={myroutes.releve_paiements} name="liste_paiements" element={<RelevePaiements />} />}

                {(profils.includes('CMPT') || profils.includes('SUPERADMIN') || profils.includes('ADMIN')) && <Route path={myroutes.etat_paiements} name="etatPaiements" element={<EtatPaiements />} />}

                {(profils.includes('SJ') || profils.includes('SUPERADMIN') || profils.includes('ADMIN') || profils.includes('PDT')) && <Route path={myroutes.communication_electronique} name="communication-electronique" element={<CommunicationElectronique />} />}
                {(profils.includes('SJ') || profils.includes('SUPERADMIN') || profils.includes('ADMIN') || profils.includes('PDT')) && <Route path={myroutes.communication_index} name="communication_index" element={<ListeCommunications />} />}

                {(profils.includes("SUPERADMIN") || profils.includes("ADMIN") || profils.includes("GEC")) &&
                <>
                <Route path={myroutes.assujetties_index} name="assujetties_index" element={<AssujettiesIndex />} />
                <Route path={myroutes.assujetties_create} name="assujetties_create" element={<AssujettiesCreate />} />
                <Route path={myroutes.assujetties_edit} name="assujetties_edit" element={<AssujettiesEdit />} />
                <Route path={`${myroutes.utilisateurs_show}/:ref`} name="utilisateurs_show" element={<UtilisateursShow />} />
                <Route path={myroutes.utilisateurs_edit} name="utilisateurs_edit" element={<UtilisateursEdit />} />
                </>
                    
                }

                {profils.includes("AJ") && <Route path={myroutes.notifications_acteur} name="notifications_acteur" element={<NotificationsActeurIndex />} />}
                {/* notifications */}
                {!profils.includes("AJ") && <Route path={myroutes.notifications_index} name="notifications_index" element={<NotificationsIndex />} />}
                

                {/** END Route BACK OFFICE */}

                {/** Repli : adresse inconnue, inaccessible avec le profil, ou lien interne incomplet */}
                <Route path="*" name="page_not_found" element={<PageNotFound />} />
                </Routes>
            </Suspense>
            </ErrorBoundary>
        </BrowserRouter>
    )
}